import Page from 'component/Page';
import { useEffect, useMemo, useState } from 'react';
import { sendPost, sendPut } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import Modal from 'component/Modal';
import UserAddAppChannel from './UserAddAppChannel';
import UserUpdateAppChannel from './UserUpdateAppChannel';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { useHistory } from 'react-router-dom';
import Paths from 'util/paths';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { useCallback } from 'react';
import { formatDate, showConfirm, showToast } from 'util/utils';
import { FaUserGroup } from 'react-icons/fa6';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

export const accountRoleNameMap = {
  0: string.ACCOUNT_ROLE_ADMIN,
  1: string.ACCOUNT_ROLE_PARENT,
  2: string.ACCOUNT_ROLE_CHILD,
};

export const accountStatusNameMap = {
  true: string.ACTIVE,
  false: string.INACTIVE,
};

const UserAppChannels = ({ userId }) => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const currentUser = useSelector(selectCurrentUser);
  const [channels, setChannels] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [selectedChannel, setSelectedChannel] = useState(null);
  const [addChannel, setAddChannel] = useState(null);
  const isAdmin = useMemo(
    () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
    [currentUser.accountRole]
  );
  const isMonitorOnly = useMemo(
    () => currentUser.isMonitorOnly === 1,
    [currentUser.isMonitorOnly]
  );
  const history = useHistory();

  //------------------------------FUNCTIONS----------------------------------------------------------
  const doSearch = useCallback(
    async (page, pageSize, getAll = false) => {
      let data = await sendPost({
        url: Urls.pocchannel.userlist,
        body: {
          id: userId,
          offset: (page - 1) * pageSize,
          size: pageSize,
          keyword: '',
        },
      });
      const { total, result } = data;
      if (!getAll) {
        setChannels(result);
        setTotal(total);
        console.log(total);
      }
      return result;
    },
    [currentUser]
  );
  useEffect(() => {
    doSearch(page, pageSize);
  }, [page, pageSize, doSearch]);
  const dataTable = useCallback(
    (data) =>
      data.map((raw, key) => ({
        key: raw.groupId,
        data: [
          raw.groupName,
          raw.status === 1 ? '有効' : '無効',
          raw.status === 1 ? (
            <OverlayTrigger
              placement="top"
              overlay={
                raw.status === 1 && (
                  <Tooltip>{`${raw.groupName}の${string.POC_CHANNEL_MEMBER}一覧へ`}</Tooltip>
                )
              }
            >
              <Button
                style={{
                  padding: '8px',
                  minWidth: '4.5em',
                  display: 'flex',
                  justifyContent: 'center',
                }}
                id={raw.groupId}
                onClick={(e) => onChannelClick(e)}
              >
                <FaUserGroup />
              </Button>
            </OverlayTrigger>
          ) : null,
          formatDate(raw.registerDate, 'YYYY/MM/DD'),
        ],
        raw,
      })),
    []
  );
  const mainActions = isMonitorOnly
    ? []
    : [
        {
          icon: 'add',
          title: string.POC_CHANNEL_CREATE_TITLE,
          onClick: () => setAddChannel({ valid: true }),
        },
      ];
  const actions = isMonitorOnly
    ? []
    : [
        { render: 'edit', onClick: ({ raw }) => setSelectedChannel(raw) },
        // ({ raw }) => {
        // 	if (raw.status === 1) {
        // 		return {
        // 			render: 'users',
        // 			onClick: ({ raw }) => history.push(`${Paths.pocchannel.detail}/?id=${raw.groupId}`)
        // 		}
        // 	}
        // },
        ({ raw }) => {
          if (raw.status === 1) {
            return {
              render: 'ban',
              className: 'color-danger',
              onClick: ({ raw }) => {
                // console.log('Ban');
                let channel = {
                  groupId: raw.groupId,
                  status: 0,
                };
                showConfirm({
                  body: string.POC_CHANNEL_DELETE_CONFIRM,
                  defaultAction: () => {
                    sendPut({
                      url: Urls.pocchannel.status,
                      body: channel,
                    })
                      .then((res) => {
                        showToast(string.POC_CHANNEL_DELETE_SUCCESS, 'success');
                        doSearch(page, pageSize);
                      })
                      .catch((e) => {
                        console.log('削除エラー');
                      });
                  },
                });
              },
            };
          } else {
            return {
              render: 'approve',
              onClick: ({ raw }) => {
                // console.log('Approve');
                let channel = {
                  groupId: raw.groupId,
                  status: 1,
                };
                showConfirm({
                  body: string.POC_CHANNEL_APPROVE_CONFIRM,
                  defaultAction: () => {
                    sendPut({
                      url: Urls.pocchannel.status,
                      body: channel,
                    })
                      .then((res) => {
                        showToast(
                          string.POC_CHANNEL_APPROVE_SUCCESS,
                          'success'
                        );
                        doSearch(page, pageSize);
                      })
                      .catch((e) => {
                        console.log('承認エラー');
                      });
                  },
                });
              },
            };
          }
        },
      ];
  const onChannelClick = (e) => {
    // console.log(e.currentTarget.id);
    let id = e.currentTarget.id;
    history.push(`${Paths.pocchannel.detail}/?id=${id}`);
  };

  //-------------------------------RETURN------------------------------------------------------------
  return (
    <>
      <Page
        // title={string.POC_CHANNEL_MANAGEMENT}
        body={
          <>
            <Table
              className="nowrap"
              mainActions={mainActions}
              page={page}
              pageSize={pageSize}
              total={total}
              onPageChanged={setPage}
              onPageSizeChanged={setPageSize}
              headers={[
                string.POC_CHANNEL_NAME,
                string.POC_CHANNEL_STATUS,
                string.POC_CHANNEL_MEMBER,
                string.POC_CHANNEL_REGISTERED_DATE,
              ]}
              data={dataTable(channels)}
              // getCSVData={async () => {
              //   return dataTable(await doSearch(1, total, true));
              // }}
              // csvFileName="SecretChannelList"
              isPaging={true}
              actions={actions}
            />
          </>
        }
      />
      <Modal
        show={!!selectedChannel}
        onHide={() => setSelectedChannel(null)}
        body={
          <>
            {!!selectedChannel && (
              <UserUpdateAppChannel
                onUpdated={() => {
                  setSelectedChannel(null);
                  doSearch(page, pageSize);
                }}
                data={selectedChannel}
              />
            )}
          </>
        }
      />

      <Modal
        show={!!addChannel}
        onHide={() => setAddChannel(null)}
        body={
          <>
            {!!addChannel && (
              <UserAddAppChannel
                onUpdated={() => {
                  setAddChannel(null);
                  doSearch(page, pageSize);
                }}
                data={{ userId, addChannel }}
              />
            )}
          </>
        }
      />
    </>
  );
};

export default UserAppChannels;
